import cx from 'classnames';
import { ComponentPropsWithoutRef, forwardRef } from 'react';

import { Popover } from '../popover';
import s from './toolbar.module.scss';

type ToolbarProps = ComponentPropsWithoutRef<'div'>;

const Toolbar = forwardRef<HTMLDivElement, ToolbarProps>(
  ({ children, className, ...props }, ref) => (
    <Popover ref={ref} className={cx(s['toolbar'], className)} {...props}>
      {children}
    </Popover>
  ),
);
Toolbar.displayName = 'Toolbar';

export { Toolbar };
